import { useState, useRef } from 'react';

export default function SwipeTest({ photos, label, prompt, onComplete }) {
  const [index, setIndex] = useState(0);
  const [opacity, setOpacity] = useState(1);
  const [advancing, setAdvancing] = useState(false);
  const resultsRef = useRef([]);
  const touchStartX = useRef(null);

  const advance = (choice) => {
    if (advancing) return;
    setAdvancing(true);
    setOpacity(0);
    resultsRef.current = [...resultsRef.current, choice];
    setTimeout(() => {
      const nextIndex = index + 1;
      if (nextIndex >= photos.length) {
        onComplete(photos, resultsRef.current);
      } else {
        setIndex(nextIndex);
        setOpacity(1);
        setAdvancing(false);
      }
    }, 200);
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const delta = e.changedTouches[0].clientX - touchStartX.current;
    touchStartX.current = null;
    if (Math.abs(delta) < 50) return;
    advance(delta > 0 ? 'yes' : 'pass');
  };

  const photo = photos[index];
  const progressPct = (index / photos.length) * 100;

  return (
    <div style={{ height: '100vh', background: '#000', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

      {/* Top bar — sits above photo layer via zIndex so gradients can never bleed through */}
      <div style={{
        flexShrink: 0, height: 50, background: '#000000',
        position: 'relative', zIndex: 2,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: '#111' }}>
          <div style={{ height: '100%', width: `${progressPct}%`, background: '#c9a84c', transition: 'width 0.3s ease' }} />
        </div>
        <span style={{ fontSize: 10, letterSpacing: 3, textTransform: 'uppercase', color: '#c9a84c' }}>
          {label} · {index + 1} / {photos.length}
        </span>
      </div>

      {/* Photo / gradient */}
      <div
        style={{ flex: '0 0 calc(70vh - 50px)', position: 'relative', overflow: 'hidden', zIndex: 1, background: photo.gradient, opacity, transition: 'opacity 0.2s ease' }}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        {photo.url && (
          <img
            src={photo.url}
            alt=""
            style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
          />
        )}
      </div>

      {/* Bottom */}
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: 28,
        padding: '0 24px', background: '#000', opacity, transition: 'opacity 0.2s ease',
      }}>
        <div style={{
          fontFamily: 'var(--font-display)',
          fontStyle: 'italic', fontSize: 14,
          color: 'rgba(255,255,255,0.38)', textAlign: 'center', lineHeight: 1.6,
        }}>
          {prompt}
        </div>

        <div style={{ display: 'flex', gap: 48, alignItems: 'center' }}>
          <button
            onClick={() => advance('pass')}
            style={{
              width: 60, height: 60, borderRadius: '50%',
              border: '1px solid #333', background: 'none',
              color: '#555', fontSize: 18, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            ✕
          </button>
          <button
            onClick={() => advance('yes')}
            style={{
              width: 60, height: 60, borderRadius: '50%',
              border: '1px solid #c9a84c', background: 'none',
              color: '#c9a84c', fontSize: 18, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            ✓
          </button>
        </div>
      </div>
    </div>
  );
}
